export enum UserTypes
{
    None,
    Admin,
    Player
}